import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

// The vendor a questionnaire was raised against. Values come from the list
// itself (registered on the context by the tab), not from the account's whole
// vendor book -- a filter that offers vendors with no questionnaires can only
// narrow to an empty table.
export const QuestionnaireVendorFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => (
    <GenericFilterDropdown
      filterParam={FilterParam.QUESTIONNAIRE_VENDOR}
      filterName={FilterName.QUESTIONNAIRE_VENDOR}
      valueKey="questionnaireVendors"
      isNested={isNested}
    />
  ),
)
